export default {
  namespaced: true,
  state: () => ({
    buyReportParams: { // 支付归因上报, 字段必须有，客户端上报没有默认字段
      origin: null,
      goodsid: null
    },
  }),
  mutations: {
    vuexBuyReportParams (state, params) {
      state.buyReportParams = { ...state.buyReportParams, ...params }
    },
  }
}
